<div class="d-flex align-items-center" [ngClass]="{'inactive-proposal': proposalIsInactive}">
    <div class="mr-3">
        <app-provider-avatar-photo [photoUrl]="getPhotoUrl(model.providerPhotoUrl)"
            [firstName]="model.providerFirstName" [lastName]="model.providerLastName" [width]="50" [height]="50">
        </app-provider-avatar-photo>
    </div>

    <div class="mr-auto">
        <div class="font-weight-bold smaller-line-height">{{model.providerFirstName}} {{model.providerLastName}}</div>
        <div class="font-weight-light smaller-line-height">
            <small>{{model.proposalCreationDate | bcDate: 'ddd, DD MMM'}}</small></div>
        <div *ngIf="model.providerComment smaller-line-height" class="font-weight-light">
            <small>"{{model.providerComment}}"</small></div>
    </div>

    <div *ngIf="shouldShowActions" [showIfPrivileges]="'SubBoard.canManageSubstitutionRequests'" [clubIds]="clubId">
        <span class="ic-ok clickable mr-2" (click)="onApprove()"
            title="{{'SubRequestDetails.ApproveTooltip' | translate}}"></span>
        <span class="ic-remove clickable" (click)="onReject()"
            title="{{'SubRequestDetails.RejectTooltip' | translate}}"></span>
    </div>

    <div *ngIf="cancelledByProvider" [showIfPrivileges]="'SubBoard.canManageSubstitutionRequests'" [clubIds]="clubId">
        <span class="badge badge-dark">{{'SubRequestDetails.CancelledByProvider' | translate}}</span>
    </div>

    <div *ngIf="rejectedByManager" [showIfPrivileges]="'SubBoard.canManageSubstitutionRequests'" [clubIds]="clubId">
        <span class="badge badge-dark">{{'SubRequestDetails.RejectedByManager' | translate}}</span>
    </div>

    <div *ngIf="approved" [showIfPrivileges]="'SubBoard.canManageSubstitutionRequests'" [clubIds]="clubId">
        <span class="badge badge-success">{{'SubRequestDetails.Approved' | translate}}</span>
    </div>

    <div *ngIf="cancelledByRequest">
        <span class="badge badge-dark">{{'SubRequestDetails.RequestCancelled' | translate}}</span>
    </div>

</div>